'use strict';

var React = require('react');

var SvgBillingStatementEuroFilledMajor = function SvgBillingStatementEuroFilledMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.32 16.467a.5.5 0 0 1-.32-.467v-11a1.5 1.5 0 0 1 1.5-1.5h7a1.5 1.5 0 0 1 1.5 1.5v11a.5.5 0 0 1-.872.334l-1.506-1.674a.494.494 0 0 0-.3-.16h-.144a.494.494 0 0 0-.3.16l-1.506 1.674a.5.5 0 0 1-.744 0l-1.506-1.674a.495.495 0 0 0-.3-.16h-.144a.495.495 0 0 0-.3.16l-1.506 1.674a.5.5 0 0 1-.551.133Zm4.94-9.074c-.248.15-.579.534-.707 1.357h1.697a.75.75 0 0 1 0 1.5h-1.697c.128.823.46 1.208.708 1.357.309.185.684.137.959-.137a.75.75 0 1 1 1.06 1.06c-.725.726-1.85.928-2.79.363-.788-.472-1.304-1.385-1.449-2.643h-.291a.75.75 0 0 1 0-1.5h.291c.145-1.258.661-2.171 1.448-2.643.941-.565 2.066-.363 2.791.363a.75.75 0 0 1-1.06 1.06c-.275-.274-.65-.322-.96-.137Z"
  }));
};
SvgBillingStatementEuroFilledMajor.displayName = "BillingStatementEuroFilledMajor";

exports.SvgBillingStatementEuroFilledMajor = SvgBillingStatementEuroFilledMajor;
